export enum VariavelAquecimentoEnum {
    aquecimento_ar_1 = 1.1,
    aquecimento_ar_2 = 2.0,
    aquecimento_ar_3 = 3.0,
}
